/** Canonical semantic JSON: sort object keys, omit undefined properties, preserve array order.
 * Callers supply JSON payloads, not class instances or cyclic objects. */
export function stableSerialize(value: unknown): string {
  if (value === null || value === undefined) return "null";
  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(",")}]`;
  }
  if (isRecord(value)) {
    const entries = Object.keys(value)
      .sort()
      .flatMap((key) => {
        const entry = value[key];
        return entry === undefined
          ? []
          : [`${JSON.stringify(key)}:${stableSerialize(entry)}`];
      });
    return `{${entries.join(",")}}`;
  }
  return JSON.stringify(value) ?? "null";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
